import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { customTheme } from 'src/styles/grid-table/grid-table-theme';
import { ProtectedArea } from '../models/protected-area.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-pa-table',
  imports: [AgGridAngular],
  template: ` <div>
    <ag-grid-angular
      style="width: 100%;"
      [columnDefs]="columnDefs"
      domLayout="autoHeight"
      [pagination]="true"
      [paginationPageSize]="10"
      [paginationPageSizeSelector]="false"
      [defaultColDef]="defaultColDef"
      [theme]="theme"
      [rowData]="protectedAreas()"
      enableCellTextSelection="true"
    />
  </div>`,
  styles: `
    ::ng-deep .ag-center-cols-viewport {
      min-height: unset !important;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaTableComponent {
  protectedAreas = input.required<ProtectedArea[]>();

  theme = customTheme;

  readonly baseUrl = environment.catNet.baseUrl;
  readonly layers = environment.catNet.activeLayers;
  readonly initialBounds = environment.catNet.initialMapBounds;

  defaultColDef: ColDef = {
    flex: 1,
    sortable: true,
    resizable: true,
  };

  columnDefs: ColDef[] = [
    {
      headerName: 'Property Name',
      field: 'propertyName',
    },
    {
      headerName: 'Original Protected Area Name',
      field: 'originalName',
      cellRenderer: (params: ICellRendererParams) => {
        const protectedAreaLink = this.buildProtectedAreaLink(params);
        return `<a href=${protectedAreaLink} target="_blank" rel="noopener noreferrer">${params.value}</a>`;
      },
    },
    {
      headerName: 'Designation Type',
      field: 'designationType',
    },
    {
      headerName: 'Designation Year',
      field: 'designationYear',
      type: 'numericColumn',
    },
    {
      headerName: 'Latitude',
      field: 'latitude',
      type: 'numericColumn',
    },
    {
      headerName: 'Longitude',
      field: 'longitude',
      type: 'numericColumn',
    },
  ];

  buildProtectedAreaLink(params: ICellRendererParams) {
    const rowData = params.data;
    return `${this.baseUrl}?activeLayers=${this.layers}&mapBounds=${this.initialBounds}&activeLocation=${rowData.latitude},${rowData.longitude}`;
  }
}
